import './Tick.scss';

import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import { ReactComponent as TickIcon } from 'assets/icons/tick.svg';
import cx from 'utils/cx';

const Tick = forwardRef(({ label, subLabel, type, disabled, ...rest }, ref) => (
  <label className={cx('tick', { disabled })}>
    <input type={type} ref={ref} disabled={disabled} {...rest} />
    <TickIcon />
    {label && (
      <span className="tick-label">
        {label}
        {subLabel && <span className="tick-sub-label">{subLabel}</span>}
      </span>
    )}
  </label>
));

Tick.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

Tick.defaultProps = {
  label: '',
  subLabel: '',
  type: 'checkbox',
  disabled: false,
};

export default Tick;
